<template>
  <Navigation :currentPage="'contact'" />
  <div class="contact">
    <table class="contactBlock">
      <tbody>
        <tr>
          <td class="firstTd">问题反馈QQ群</td>
          <td>723749541</td>
        </tr>
        <tr>
          <td class="firstTd">联系人</td>
          <td>黄先生</td>
        </tr>
        <tr>
          <td class="firstTd">电话</td>
          <td>13585542899</td>
        </tr>
        <tr>
          <td class="firstTd">邮箱</td>
          <td>41863805@qq.com</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  name: 'ContactView',
  components: {
    Navigation: Navigation
  }
}
</script>

<style>

.contact{
    width: fit-content;
    margin: 360px auto;
    display: flex;
    flex-direction: row;
}

table{
  table-layout: fixed;
  border-spacing: 24px 0;
}

.contact td{
  list-style: none;
  color: gray;
}

.firstTd{
  text-align: right;
  text-justify: distribute;
  text-justify: inter-word;
  text-justify: inter-ideograph;
  line-height: 36px;
  color: gray;
  padding-right: 24px;
  border-right: 2px solid #45B5B5;
}

</style>
